import OrderPersInfoJapanForm from './OrderPersInfoJapanForm'

export default OrderPersInfoJapanForm
